import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';

const tagPercentages = {
  'olive dress': 0.13,
  'vacation dress': 0.13,
  'mini dress': 0.13,
  'naomi dress': 0.13,
  'greta dress': 0.12,
  'maxi dress': 0.12,
  'casual dress': 0.12,
  dress: 0.12,
  jumpsuit: 0.12,
  'eloise dress': 0.12,
  'stevie dress': 0.11,
  'rayon dress': 0.11,
  'midi skirt': 0.11,
  'work dress': 0.11,
  'frida dress': 0.11,
  jackets: 0.1,
  'leah dress': 0.1,
  'dahlia dress': 0.1,
  'kids dress': 0.1,
  'big pocket dress': 0.1,
  'party dress': 0.1,
  dresses: 0.1,
  'rayon skirt': 0.1,
  'slip skirt': 0.09,
  skirt: 0.09,
  pants: 0.087,
  D380: 0.087,
  grid: 0.085,
  mushroom: 0.083,
  L05: 0.081,
  'witchy ways': 0.087,
  'zero waste': 0.087,
  'tarot print': 0.087,
  'cloud people': 0.087,
  'psychedelic eyes': 0.087,
  'cosmic ladies': 0.087,
  'magic suits': 0.087,
  'unicorn print': 0.087,
  'Tarot Garden': 0.087,
  'magic suit': 0.087,
  'garden suit': 0.087,
  'bug out': 0.087,
  'pool party': 0.087,
  'dog party': 0.087,
  'pink squiggle': 0.087,
  'awesome blossom': 0.087,
  'mean machine': 0.087,
  'tiny deer': 0.087,
  'lobster dream': 0.087,
  'burger babie': 0.087,
  'zig zag': 0.087,
  'Dutch Garden': 0.087,
  'while odin sleeps': 0.087,
  'people ive loved': 0.087,
  'Roll Out': 0.087,
  'Summer Daze': 0.087,
  'astral weekend': 0.087,
  'patch ya later': 0.087,
  'rainbow drops': 0.087,
  'better days': 0.087,
  'desert disaster': 0.087,
  'salad days': 0.087,
  'slow fashion': 0.087,
  'sustainable fashion': 0.087,
  'Classic Button Down': 0.086,
  'extended size': 0.086,
  'kids jogger': 0.086,
  'DORCAS MAGDABELO': 0.086,
  se047: 0.086,
  'summer tank': 0.086,
  'twill set': 0.086,
  'twill sets': 0.086,
  'napkin set': 0.086,
  naomi: 0.086,
  overalls: 0.086,
  'oversized tee': 0.086,
  'naomi anderson Subryan': 0.086,
  art: 0.086,
  'Lauren west': 0.086,
  D347: 0.086,
  bag: 0.086,
  se030: 0.086,
  D350: 0.086,
  primecut: 0.086,
  'button down': 0.086,
  'Naomi Anderson': 0.086,
  'no returns': 0.086,
  underwear: 0.086,
  eugenia: 0.086,
  D317: 0.086,
  SE037: 0.086,
  'casual bell': 0.086,
  SE025: 0.086,
  'dea dia': 0.086,
  joggers: 0.086,
  'delaney and blu': 0.086,
  d219: 0.086,
  'lovely leah': 0.086,
  circle: 0.086,
  D293: 0.086,
  k06: 0.086,
  unisex: 0.086,
  SE039: 0.086,
  'soft bra': 0.086,
  'soft bras': 0.086,
  eloise: 0.086,
  stevie: 0.086,
  SE026: 0.086,
  b001: 0.086,
  'dopp bag': 0.086,
  norris: 0.086,
  'meg lewis': 0.086,
  pink: 0.086,
  sale: 0.05,
  'art print': 0.086,
  d346: 0.086,
  D335: 0.086,
  'colette bernard': 0.086,
  'solid black': 0.086,
  'twill jacket': 0.086,
  'checkered patch': 0.086,
  'tote bag': 0.086,
  'Pippa Toole': 0.086,
  thegoodtwin: 0.086,
  D314: 0.086,
  se024: 0.086,
  dahlia: 0.086,
  'Dorcas Magbadelo': 0.086,
  'ash & chess': 0.086,
  shorts: 0.086,
  Greta: 0.086,
  yourbuddymeg: 0.086,
  coat: 0.086,
  outerwear: 0.086,
  'Kristen Liu-': 0.086,
  'art teachers': 0.086,
  'Lauren Cat West': 0.086,
  hastings: 0.086,
  Berry: 0.086,
  'kids tee': 0.086,
  keychain: 0.086,
  'Dorcas Code': 0.086,
  L02: 0.086,
  'Char Bataille': 0.086,
  'Cry Baby': 0.086,
  plus: 0.086,
  d321: 0.086,
  d330: 0.086,
  lobster: 0.086,
  sw012: 0.086,
  special: 0.086,
  'addeline griswold': 0.086,
  pins: 0.086,
  'party tee': 0.086,
  'tiny dancer': 0.086,
  'GENTLE THRILLS': 0.086,
  MackBeck: 0.086,
  neya: 0.086,
  'stocking stuffer': 0.086,
  cotton: 0.086,
  CLOUDS: 0.086,
  Tarot: 0.086,
  turtleneck: 0.086,
  'art teacher': 0.086,
  'Perry flower': 0.086,
  'circa 78 designs': 0.086,
  Auderpopz: 0.086,
  Block: 0.086,
  Gentilhomme: 0.086,
  pin: 0.086,
  'cf-size-2-year': 0.086,
  legging: 0.086,
  turtlenecks: 0.086,
  'peach fuzz': 0.086,
  'kick flare': 0.086,
  se053: 0.086,
  'Mitchelle Norris': 0.086,
  'rachel breeden': 0.086,
  'cf-size-3-year': 0.086,
  PATCH: 0.086,
  ortiz: 0.086,
  socks: 0.086,
  'Enikő Katalin Eged': 0.086,
  'Ève Gentilhomme': 0.086,
  'plus size': 0.086,
  'cf-size-1-year': 0.086,
  k12: 0.086,
  'Kids Leggings': 0.086,
  NWhome: 0.086,
  macarena: 0.086,
  'macarena luzi': 0.086,
  ayesha: 0.086,
  ACCESSORIES: 0.086,
  lydiaortiz: 0.086,
  trees: 0.086,
  SE035: 0.086,
  jammin: 0.086,
  circa: 0.086,
  'running loWongw': 0.086,
  'cf-size-medium': 0.086,
  lydia_ortiz: 0.086,
  'shelby works': 0.086,
  zander: 0.086,
  TAXI: 0.086,
  'micotti cat': 0.086,
  'Ayesha Rana': 0.086,
  wolverine: 0.086,
  'lisa congdon': 0.086,
  accessory: 0.086,
  pippa: 0.086,
  'lucy kirk': 0.086,
  Wormiverse: 0.086,
  leggings: 0.086,
  S23SALE: 0.05,
  congdon: 0.086,
  vases: 0.086,
  d320: 0.086,
  vacation: 0.086,
  cards: 0.086,
  se050: 0.086,
  WSALE22: 0.05,
  SE052: 0.05,
  tropico: 0.086,
  'lauren lester': 0.086,
  forager: 0.086,
  'leila simon hayes': 0.086,
  Pots: 0.086,
  bandana: 0.086,
  J005: 0.086,
  'ruth mora': 0.086,
  ansley: 0.086,
  'Ansley Randall': 0.086,
  'zander schlacter': 0.086,
  black: 0.086,
  jogger: 0.086,
  'molly fitzpatrick': 0.086,
  unicorn: 0.086,
  'mock neck': 0.086,
  SE032: 0.086,
  'amy hastings': 0.086,
  jacket: 0.086,
  Berries: 0.086,
  'cf-size-large': 0.086,
  'mock necks': 0.086,
  se027: 0.086,
  'big pocket': 0.086,
  hat: 0.086,
  haze: 0.086,
  necklace: 0.086,
  odin: 0.086,
  ditto: 0.086,
  D261: 0.086,
  mut: 0.086,
  D323: 0.086,
  dittohouse: 0.086,
  'party mix': 0.086,
  intimate: 0.086,
  d285: 0.086,
  Dreyfus: 0.086,
  athleisure: 0.086,
  solid: 0.086,
  spooky: 0.086,
  canvas: 0.086,
  'cf-size-xlarge': 0.086,
  chunks: 0.086,
  intimates: 0.086,
  SE017: 0.086,
  'twill cotton': 0.086,
  'Jackie Brown': 0.086,
  D398: 0.086,
  Frida: 0.086,
  d310: 0.086,
  claw: 0.086,
  squiggle: 0.086,
  coverall: 0.086,
  coveralls: 0.086,
  solids: 0.086,
  'Kristina Micotti': 0.086,
  'fit and flare': 0.086,
  joyce: 0.086,
  'Lex Gjurasic': 0.086,
  'the good twin': 0.086,
  meadow: 0.086,
  'hair clips': 0.086,
  "women's": 0.086,
  gifts: 0.086,
  nwbag: 0.086,
  'cf-size-2x': 0.086,
  'cf-size-small': 0.086,
  home: 0.086,
  'cotton poplin': 0.086,
  card: 0.086,
  GIFT: 0.086,
  gift: 0.086,
  'Tara Booth': 0.086,
  FAIRE: 0.086,
  'Krista Perry': 0.086,
  'cf-size-xsmall': 0.086,
  'cf-size-3x': 0.086,
  'Audrey Herbertson': 0.086,
  'Home goods': 0.086,
  'Kitiya Palaskas': 0.086,
  'ash and chess': 0.086,
  CP: 0.086,
  'lydia ortiz': 0.086,
  sleeveless: 0.086,
  bags: 0.086,
  PPK: 0.086,
  'long sleeve': 0.086,
  paper: 0.086,
  'extended sizes': 0.086,
  hair: 0.086,
  'Aga Giecko': 0.086,
  kid: 0.086,
  BHS: 0.086,
  'paper goods': 0.086,
  kids: 0.086,
  linen: 0.086,
  more: 0.086,
  sticker: 0.086,
  'stocking stuffers': 0.086,
  stickers: 0.086,
  twill: 0.086,
  rayon: 0.086,
  earrings: 0.086,
  'short sleeve': 0.086,
  AUG24SALE: 0.05,
  W25SALE: 0.05,
  jewelry: 0.086,
  poplin: 0.086,
  women: 0.086,
  sustainable: 0.086,
  jersey: 0.086,
  accessorie: 0.086,
  accessories: 0.086,
  nooworks: 0.086,
  bolo: 0.085,
  'molly anne bishop': 0.084,
  SE073: 0.084,
  se055: 0.083,
  dogs: 0.082,
  bottoms: 0.081,
  bottom: 0.081,
  b003: 0.081,
  'kick flare pant': 0.075,
  'muscle tee': 0.075,
  'ruffle tops': 0.075,
  tops: 0.075,
  'linen pants': 0.074,
  'puff top': 0.074,
  'crop tops': 0.074,
  'linen bottom': 0.073,
  'crop top': 0.073,
  'linen top': 0.073,
  'tank top': 0.073,
  'skinny pant': 0.072,
  'track top': 0.072,
  'ruffle top': 0.072,
  top: 0.072,
  'painter pant': 0.07,
  'painter pants': 0.07,
  'party pant': 0.07,
  'catalina pant': 0.07,
  'catalina pants': 0.07,
  'cannot return': 0.0,
  'no-returns': 0.06,
  'final sale': 0.05,
  salesalesale: 0.05,
  j24sale: 0.05,
};

export const nooworksShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({
      sizes: [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'xxlarge',
        'xxxlarge',
        '2X',
        '3X',
        '4X',
        '5X',
      ],
    }),
  ],
  resaleValueConfig: {
    categoryPercentages: {}, // No category-specific percentages defined — Nooworks does not use a category config
    tagPercentages,
  },
};
